import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EventPage from './pages/EventPage';
import OrganizerDashboard from './pages/OrganizerDashboard';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import InvitationPage from './pages/InvitationPage';
import InvitationSuccessPage from './pages/InvitationSuccessPage';
import InvitationDeclinedPage from './pages/InvitationDeclinedPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import OrganizersPage from './pages/OrganizersPage';
import CodeOfConduct from './pages/CodeOfConduct';
import TicketVerificationPage from './pages/TicketVerificationPage';
import VerifyPage from './pages/VerifyPage';
import { QRScannerPage } from './pages/QRScannerPage';
import SocialCardGenerator from './pages/SocialCardGenerator';
import MediaGenerator from './pages/MediaGenerator';
import SponsorsPage from './pages/SponsorsPage';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/event/:id" element={<EventPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<OrganizerDashboard />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/organizers" element={<OrganizersPage />} />
          <Route path="/organizers/events/:id/media" element={<MediaGenerator />} />
          <Route path="/organizers/sponsors" element={<SponsorsPage />} />
          <Route path="/organizer/scanner" element={<QRScannerPage />} />
          <Route path="/invite/:code" element={<InvitationPage />} />
          <Route path="/invitation-success" element={<InvitationSuccessPage />} />
          <Route path="/invitation-declined" element={<InvitationDeclinedPage />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/verify-ticket/:token" element={<TicketVerificationPage />} />
          <Route path="/verify/:token" element={<VerifyPage />} />
          <Route path="/social-card/:ticketCode" element={<SocialCardGenerator />} />
        </Routes>
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
